import useEventTrackingLogEvent, {
  categories,
  eventTypes,
} from 'EventTracking/useEventTrackingLogEvent';

// TODO:
// -- allocation
// table header click

const SEPARATOR = '>';
const ACTIVITY_SUMMARY = 'Activity Summary';
const ALLOCATION = 'Allocation';
const PORTFOLIO = 'Portfolio';
const HOLDINGS = 'Holdings';
const COMMENTARY = 'Commentary';
const FEEDBACK = 'Feedback';

// tabs
const BALANCE = 'Balance';
// const TRANSACTIONS = 'Transactions';
const PERFORMANCE = 'Performance';
// const DOCUMENTS = 'Documents';
// const INFO = 'Info';

function buildEventName(eventCrumbs = []) {
  return eventCrumbs.join(` ${SEPARATOR} `);
}

export function logMetaQueryFieldGroupChange(values, field, newValue, logger) {
  const fieldName = field.attr('name');
  const oldValue = values[fieldName];

  let eventName = `Changed ${fieldName} to ${newValue}`;
  if (fieldName === 'startDate' || fieldName === 'endDate') {
    eventName = `Changed ${fieldName}`;
  }

  const eventProperties = {
    ...values,
    [fieldName]: newValue,
    oldValue,
  };
  if (eventProperties.datePeriod !== 'custom') {
    delete eventProperties.startDate;
    delete eventProperties.endDate;
  }

  logger(eventName, eventProperties);
}

export default function useManagedAccountPageEventLogger() {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  function logEvent(eventCrumbs, eventProperties = {}) {
    const eventName = buildEventName(eventCrumbs);
    logStandardizedEvent(
      categories.managedAccountPage,
      eventTypes.click,
      'click',
      {
        eventProperties: {
          ...eventProperties,
          eventName,
        },
      },
    );
  }

  // common events
  const logHeaderEvent = (eventName, eventProperties) => logEvent(['Header', eventName], eventProperties);
  const logTopBarEvent = (eventName, eventProperties) => logEvent(['Top Bar', eventName], eventProperties);
  const logTabsEvent = (eventName, eventProperties) => logEvent(['Tabs', eventName], eventProperties);

  // balance tab events
  const logActivitySummaryFiltersEvent = (eventName, eventProperties) => logEvent([BALANCE, `${ACTIVITY_SUMMARY} Filters`, eventName], eventProperties);
  const logActivitySummaryChartEvent = (eventName, eventProperties) => logEvent([BALANCE, `${ACTIVITY_SUMMARY} Chart`, eventName], eventProperties);
  const logActivitySummaryInfo = (eventName, eventProperties) => logEvent([BALANCE, `${ACTIVITY_SUMMARY} Info`, eventName], eventProperties);
  const logPortfolioChart = (eventName, eventProperties) => logEvent([BALANCE, `${PORTFOLIO} Chart`, eventName], eventProperties);
  const logHoldingsTable = (eventName, eventProperties) => logEvent([BALANCE, `${HOLDINGS} Table`, eventName], eventProperties);

  // performance tab events
  const logAllocationPieChart = (eventName, eventProperties) => logEvent([PERFORMANCE, `${ALLOCATION} Pie Chart`, eventName], eventProperties);
  const logPortfolioPieChart = (eventName, eventProperties) => logEvent([PERFORMANCE, `${PORTFOLIO} Pie Chart`, eventName], eventProperties);
  const logPortfolioAllocationPieChart = (eventName, eventProperties) => logEvent([PERFORMANCE, `${PORTFOLIO} ${ALLOCATION} Pie Chart`, eventName], eventProperties);
  const logPortfolioHorizontalBarChart = (eventName, eventProperties) => logEvent([PERFORMANCE, `${PORTFOLIO} Horizontal Bar Chart`, eventName], eventProperties);
  const logPortfolioList = (eventName, eventProperties) => logEvent([PERFORMANCE, `${PORTFOLIO} List`, eventName], eventProperties);
  const logPerformanceFiltersEvent = (eventName, eventProperties) => logEvent([PERFORMANCE, `${PERFORMANCE} Filters`, eventName], eventProperties);
  const logPerformanceChartEvent = (eventName, eventProperties) => logEvent([PERFORMANCE, `${PERFORMANCE} Chart`, eventName], eventProperties);
  const logCommentaryEvent = (eventName, eventProperties) => logEvent([PERFORMANCE, COMMENTARY, eventName], eventProperties);
  const logCommentaryFeedbackEvent = (eventName, eventProperties) => logEvent([PERFORMANCE, COMMENTARY, FEEDBACK, eventName], eventProperties);

  return {
    logEvent,
    logHeaderEvent,
    logTopBarEvent,
    logTabsEvent,
    logActivitySummaryFiltersEvent,
    logActivitySummaryChartEvent,
    logActivitySummaryInfo,
    logPortfolioChart,
    logHoldingsTable,
    logAllocationPieChart,
    logPortfolioPieChart,
    logPortfolioAllocationPieChart,
    logPortfolioHorizontalBarChart,
    logPortfolioList,
    logPerformanceFiltersEvent,
    logPerformanceChartEvent,
    logCommentaryEvent,
    logCommentaryFeedbackEvent,
  };
}
